import { createStore } from "redux";
import toggleMenuReducer from "./reducers/toggleMenuReducer";

function configureStore(state = { toggleMenu: true }) {
  return createStore(toggleMenuReducer, state);
}

export default configureStore;
